import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e2745dc&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2e2745dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2745dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2745dc')) {
      api.createRecord('2e2745dc', component.options)
    } else {
      api.reload('2e2745dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e2745dc&scoped=true", function () {
      api.rerender('2e2745dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DefaultEntryPage/superTubePage/index.vue"
export default component.exports